export default __webpack_public_path__ + "21baceb2e96d89607cbd96caa5a5be48.png";